import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { ReportRatingCard } from '../../components/manutenzione/ReportRatingCard';
import { PhotoUpload } from '../../components/manutenzione/PhotoUpload';
// Mock resolved report - SOLO oggetto rotto
const resolvedReport = {
  id: '1',
  type: 'Oggetto Rotto'
};
type SolutionType = 'partial' | 'complete' | 'custom' | '';
export function CompletionFormPage() {
  const navigate = useNavigate();
  const [rating, setRating] = useState({
    descriptionAccuracy: 0,
    photoAccuracy: 0,
    actualSeverity: 0
  });
  const [solutionType, setSolutionType] = useState<SolutionType>('');
  const [customSolution, setCustomSolution] = useState('');
  const [description, setDescription] = useState('');
  const [finalPhoto, setFinalPhoto] = useState('');
  const handleRatingChange = (field: string, value: number) => {
    setRating(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const isValid = () => {
    // Check all ratings are filled
    const allRatingsComplete = rating.descriptionAccuracy > 0 && rating.photoAccuracy > 0 && rating.actualSeverity > 0;
    // Check solution type
    const solutionValid = solutionType !== '' && (solutionType !== 'custom' || customSolution.trim().length > 0);
    // Check description (minimo 15 caratteri)
    const descriptionValid = description.trim().length >= 15;
    // Check photo
    const photoValid = finalPhoto !== '';
    return allRatingsComplete && solutionValid && descriptionValid && photoValid;
  };
  const handleSubmit = () => {
    if (isValid()) {
      console.log('Submitting:', {
        rating,
        solutionType,
        customSolution,
        description,
        finalPhoto
      });
      // Navigate to completion confirmation
      navigate('/manutenzione/completion-confirmation');
    }
  };
  const getSolutionLabel = () => {
    if (solutionType === 'partial') return 'Riparazione parziale';
    if (solutionType === 'complete') return 'Riparazione completa';
    if (solutionType === 'custom') return customSolution;
    return '';
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1423">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-32" data-id="element-1424">
        {/* Header */}
        <div className="flex items-center justify-between mb-12" data-id="element-1425">
          <h1 className="text-4xl font-bold text-navy" data-id="element-1426">Concludi Intervento</h1>
          <button onClick={() => navigate(-1)} className="w-12 h-12 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors touch-manipulation" data-id="element-1427">
            <X className="w-6 h-6 text-gray-600" data-id="element-1428" />
          </button>
        </div>

        {/* Valutazione Segnalazione */}
        <div className="mb-12" data-id="element-1429">
          <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1430">
            Valutazione Segnalazione
          </h2>
          <ReportRatingCard reportType={resolvedReport.type} rating={rating} onChange={handleRatingChange} data-id="element-1431" />
        </div>

        {/* Come hai risolto */}
        <div className="mb-12" data-id="element-1432">
          <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1433">Come hai risolto</h2>

          <div className="space-y-6" data-id="element-1434">
            {/* Tipo soluzione - 3 opzioni */}
            <div data-id="element-1435">
              <label className="block text-base font-semibold text-gray-700 mb-3" data-id="element-1436">
                Tipo di soluzione
              </label>
              <div className="space-y-3" data-id="element-1437">
                <button onClick={() => setSolutionType('partial')} className={`w-full p-4 rounded-xl border-2 transition-all text-left ${solutionType === 'partial' ? 'border-teal-deep bg-teal-50/30' : 'border-gray-200 hover:border-gray-300 bg-white'}`} data-id="element-1438">
                  <span className="text-base font-semibold text-navy" data-id="element-1439">
                    Riparazione parziale
                  </span>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1440">
                    Il problema è stato risolto temporaneamente
                  </p>
                </button>

                <button onClick={() => setSolutionType('complete')} className={`w-full p-4 rounded-xl border-2 transition-all text-left ${solutionType === 'complete' ? 'border-teal-deep bg-teal-50/30' : 'border-gray-200 hover:border-gray-300 bg-white'}`} data-id="element-1441">
                  <span className="text-base font-semibold text-navy" data-id="element-1442">
                    Riparazione completa
                  </span>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1443">
                    Il problema è stato risolto definitivamente
                  </p>
                </button>

                <button onClick={() => setSolutionType('custom')} className={`w-full p-4 rounded-xl border-2 transition-all text-left ${solutionType === 'custom' ? 'border-teal-deep bg-teal-50/30' : 'border-gray-200 hover:border-gray-300 bg-white'}`} data-id="element-1444">
                  <span className="text-base font-semibold text-navy" data-id="element-1445">
                    Altro (specifica)
                  </span>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1446">
                    Descrivi il tipo di intervento effettuato
                  </p>
                </button>
              </div>

              {/* Custom solution input */}
              {solutionType === 'custom' && <div className="mt-4" data-id="element-1447">
                  <input type="text" value={customSolution} onChange={e => setCustomSolution(e.target.value)} placeholder="Es: Sostituzione componente, Pulizia straordinaria..." className="w-full h-12 px-4 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-1448" />
                </div>}
            </div>

            {/* Descrizione intervento - MINIMO 15 CARATTERI */}
            <div data-id="element-1449">
              <label className="block text-base font-semibold text-gray-700 mb-3" data-id="element-1450">
                Descrizione intervento
              </label>
              <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Descrivi brevemente cosa hai fatto... (minimo 15 caratteri)" rows={4} className={`w-full px-4 py-3 bg-white border-2 rounded-xl focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all resize-none ${description.length > 0 && description.length < 15 ? 'border-red-300' : 'border-gray-200'}`} data-id="element-1451" />
              <div className="flex items-center justify-between mt-2" data-id="element-1452">
                <p className={`text-sm ${description.length >= 15 ? 'text-green-600' : description.length > 0 ? 'text-red-600' : 'text-gray-500'}`} data-id="element-1453">
                  {description.length >= 15 ? '✓ Descrizione valida' : `Minimo 15 caratteri richiesti (${description.length}/15)`}
                </p>
                <p className="text-sm text-gray-400" data-id="element-1454">
                  {description.length}/1000
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Foto Finale */}
        <div className="mb-12" data-id="element-1455">
          <h2 className="text-xl font-bold text-navy mb-6" data-id="element-1456">Foto Finale</h2>
          <PhotoUpload photo={finalPhoto} onPhotoChange={setFinalPhoto} required data-id="element-1457" />
        </div>
      </div>

      {/* Fixed Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 md:p-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40" data-id="element-1458">
        <div className="max-w-4xl mx-auto" data-id="element-1459">
          <Button onClick={handleSubmit} disabled={!isValid()} className={`w-full text-lg h-14 ${!isValid() ? 'opacity-40 cursor-not-allowed' : ''}`} data-id="element-1460">
            Invia e Concludi
            <CheckCircle className="w-5 h-5 ml-2" data-id="element-1461" />
          </Button>
        </div>
      </div>
    </div>;
}